import { render } from "./AnimateShow.vue?vue&type=template&id=1ca6bf68"
import script from "./AnimateShow.vue?vue&type=script&lang=js"
export * from "./AnimateShow.vue?vue&type=script&lang=js"
script.render = render

export default script